// extracted by mini-css-extract-plugin
module.exports = {"quickLinks":"styles-module--quickLinks--2hfah","image":"styles-module--image--iP7Np"};